<template>
    <div>
        <a class="btn ps-btn" @click.prevent="show" href="#">
            <span>{{btnTitle}}</span>
        </a>

        <form @submit.prevent="post">
            <vue-modal
                    v-if="isModalVisible"
                    modal_title="Promotion"
                    container_style="min-width:60%;height:500px;overflow:visible;text-align:left;margin-top:100px;position:relative;z-index:999;"
                    body_container_style="min-width:60%;height:500px;overflow:visible;padding:0;"
                    @close="hide"
            >
                <template v-slot:header>
                    <div class="modaltitleheader pt-3 pb-3" style="height: auto !important;">
                        <h4>Add Promotion</h4>
                    </div>

                </template>
                <template v-slot:body>
                    <div v-if="loading" class="cp-field d-flex justify-content-center">
                        <div class="form-row">
                            <div class="form-group col">
                                <label>
                                    <loading
                                            :active="loading"
                                            :can-cancel="false"
                                            loader="dots"
                                            color="#2292ef"
                                            :is-full-page="false"
                                    ></loading>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <h4 class="mt-5 d-flex justify-content-center" v-if="_userProduct.promotion">
                            Promotion is <span class="h3 ml-2 text-success" v-if="_userProduct.promotion.is_active"> Active</span><span
                                class="h3 ml-2 text-danger" v-else> Expired</span>
                        </h4>

                        <div class="cp-field">
                            <div class="form-row">
                                <div class="form-group col-4">
                                    <label for="percent">Percent</label>
                                    <input type="text" id="percent" class="form-control" v-model="percent"/>
                                </div>
                                <div class="form-group col-4">
                                    <label for="start_date">Start date</label>
                                    <VueCtkDateTimePicker
                                            :onlyDate="true"
                                            formatted="ll"
                                            format="YYYY-MM-DD"
                                            v-model="start"
                                            locale="en"
                                    >
                                        <input type="text" class="form-control" v-model="start"/>
                                    </VueCtkDateTimePicker>
                                </div>
                                <div class="form-group col-4">
                                    <label for="end_date">End date</label>
                                    <VueCtkDateTimePicker
                                            :onlyDate="true"
                                            formatted="ll"
                                            format="YYYY-MM-DD"
                                            v-model="end"
                                            locale="en"
                                    >
                                        <input type="text" class="form-control" v-model="end"/>
                                    </VueCtkDateTimePicker>
                                </div>
                            </div>
                        </div>

                        <div class="save-stngs pd2 d-flex justify-content-center">
                            <ul>
                                <li>
                                    <button class="ps-btn ps-btn--sm ps-btn--gradient btn-fsdfh" type="submit"
                                            style="margin-top:14px;">Save
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>


                </template>
                <template v-slot:footer>
                    <div></div>
                </template>
            </vue-modal>
        </form>

    </div>
</template>

<script>
    import VueModal from "./../../../VueModal";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import EventBus from '../../../../front/eventBus';


    export default {
        components: {
            VueModal,
            Loading,
        },
        props: [
            'userProduct',
            'buttonTitle',
        ],
        data() {
            return {
                loading: false,
                productId: null,
                isModalVisible: false,
                percent: null,
                start: null,
                end: null,
                status: null,
                promotionId: null,
                isEditable: null,
                btnTitle: null,
                _userProduct: null,
            }
        },
        mounted() {
            this.btnTitle = this.buttonTitle;
            this._userProduct = this.userProduct;
            this.productId = this._userProduct.product_id;
            if (this._userProduct.promotion) {
                this.promotionId = this._userProduct.promotion.id;
                this.percent = this._userProduct.promotion.discount;
                this.start = this._userProduct.promotion.start_date;
                this.end = this._userProduct.promotion.end_date;
            }
        },
        methods: {
            show() {
                this.isModalVisible = true;
            },
            hide() {
                this.isModalVisible = false;
            },
            post() {
                if (this.promotionId === null) {
                    this.store();
                } else {
                    this.update();
                }
            },
            store() {
                this.$Progress.start();
                let self = this;
                let data = {
                    product_id: self.productId,
                    percent: self.percent,
                    start_date: self.start,
                    end_date: self.end
                };

                axios({
                    method: "post",
                    url: "/api/v1/trader-promotion?&api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$Progress.finish();
                            self.$toast.success(res.data.msg);
                            self.hide();
                            EventBus.$emit('PROMOTION_CHANGED')
                        } else {
                            self.$Progress.fail();
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.$Progress.fail();
                        console.log(err);
                        if (err.response.status == 422) {
                            let errors = err.response.data.errors;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        }
                        if (err.response.status == 403) {
                            if (err.response.data.type && err.response.data.type === 'canFeatureValidation') {
                                window.subscriptionRequired()
                            }else{
                                self.$toast.error(err.response.data.message);
                            }
                        }
                    });

            },
            update() {
                this.$Progress.start();
                let self = this;
                let data = {
                    product_id: self.productId,
                    percent: self.percent,
                    start_date: self.start,
                    end_date: self.end
                };

                axios({
                    method: "put",
                    url: "/api/v1/trader-promotion/" + self.promotionId + "?&api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$Progress.finish();
                            self.$toast.success(res.data.msg);
                            self.hide();
                            self.$emit('update');
                            EventBus.$emit('PROMOTION_CHANGED')
                        } else {
                            self.$Progress.fail();
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.$Progress.fail();
                        console.log(err);
                        if (err.response.status == 422) {
                            let errors = err.response.data.errors;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        }
                    });

            }
        }
    }
</script>

<style scoped>

</style>